import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { LoadingMenu } from '../../../../../../components/LoadingSpinner';
import SelectPill from '../../../../../../components/SelectPill';
import { useProductFilter } from '../../hooks/useProductFilter';
import { PRODUCT_TYPE_LIST } from '../../constants';
import arrowRightIcon from '../../../../../../assets/icons/icon_arrow-right-gray.svg';
import styles from './ProductSelect.module.scss';
import { useOmnichannelStore } from '../../store/ModuloOmnichannel.store';
import { LocaleType } from '../../types';

type ProductSelectProps = {
  locale: LocaleType;
};

const renderMenu = (menu: React.ReactNode) => (
  <span>
    <LoadingMenu area="product-filter" />
    {menu}
  </span>
);

const changePlaceholder = (list: string[]) => {
  return list.length > 0 ? 'Produtos selecionados' : 'Escolha os produtos *';
};

export const ProductSelect = ({ locale }: ProductSelectProps) => {
  const produto = useOmnichannelStore(state => state.produto);
  const productFilterType = useOmnichannelStore(state => state.productFilterType);
  const omnichannelRequestBody = useOmnichannelStore(state => state.omnichannelRequestBody);
  const setOmnichannelState = useOmnichannelStore(state => state.setOmnichannelState);

  const { productHandlers } = useProductFilter();
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  React.useEffect(() => {
    setValue('produtos', produto.value, { shouldValidate: true });
  }, [produto.value, setValue]);

  const handleSelectProductTypeFilter = (value: string) => {
    const requestBody = {
      ...omnichannelRequestBody,
      gtins: [],
    };
    setOmnichannelState('productFilterType', value as 'TODOS' | 'ESPECIFICOS');
    if (value === 'TODOS') {
      setValue('produtos', []);
      setOmnichannelState('omnichannelRequestBody', requestBody);
    }
  };

  return (
    <div className={styles['select-pill-wrapper']}>
      <Controller
        name="tipoGtin"
        control={control}
        render={({ field }) => (
          <SelectPill
            id="select-picker-pill"
            placeholder="Escolha uma opção"
            searchable={false}
            name="tipoGtin"
            cleanable={false}
            data={PRODUCT_TYPE_LIST}
            value={field.value}
            onSelect={(value: string) => {
              field.onChange(value);
              handleSelectProductTypeFilter(String(value));
            }}
          />
        )}
      />
      {productFilterType === 'ESPECIFICOS' ? (
        <>
          <img src={arrowRightIcon} alt="" className={styles['arrow-right-icon']} />
          <Controller
            name="produtos"
            control={control}
            render={({ field }) => (
              <SelectPill
                id={errors?.produtos ? 'select-pill-is-empty' : 'check-picker-pill'}
                type="check"
                placeholder={changePlaceholder(field.value || [])}
                name="produtos"
                value={field.value}
                data={produto.list || []}
                onSearch={(value: string) => productHandlers.onSearchProducts(value)}
                onOpen={() => productHandlers.onSearchProducts('')}
                onChange={(value: string | string[]) => {
                  const next = Array.isArray(value) ? value : value ? [String(value)] : [];
                  field.onChange(next);
                  productHandlers.handleSelectProduct(next);
                }}
                onClean={() => {
                  field.onChange([]);
                  productHandlers.handleClearProducts();
                }}
                locale={locale}
                renderMenu={renderMenu}
              />
            )}
          />
        </>
      ) : null}
    </div>
  );
};
